// src/store/index.ts

// third-party
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, TypedUseSelectorHook } from 'react-redux';
import { createLogger } from 'redux-logger';

// project-imports
import reducers from './reducers';
import baseApi from 'api/base';
import { rtkQueryErrorHandler } from './middlewares/error-handler';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const logger = createLogger({
  collapsed: true,
  diff: true
});

const middleware = (getDefaultMiddleware: any) => {
  let middleware = getDefaultMiddleware({
    serializableCheck: false
  }).concat([baseApi.middleware, rtkQueryErrorHandler]);

  if (process.env.NODE_ENV === 'development') {
    middleware = middleware.concat(logger);
  }
  return middleware;
};

const store = configureStore({
  reducer: reducers,
  middleware
});

export type RootState = ReturnType<typeof reducers>;

export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { store, dispatch, useSelector, useDispatch };
